import * as React from "react";
import { BaseInput, type BaseInputProps } from "./BaseInput";

export interface TextInputProps extends Omit<BaseInputProps, "type"> {
  /**
   * Input type - mặc định là text
   */
  type?: "text" | "email" | "tel" | "url" | "search" | "password" | "time" | "number";
}

/**
 * TextInput component - Text input với MEBI Design System
 *
 * @example
 * ```tsx
 * <TextInput
 *   label="Họ và tên"
 *   placeholder="Nhập họ và tên của bạn"
 *   error="Họ và tên không được để trống"
 * />
 * ```
 */
const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  ({ type = "text", ...props }, ref) => {
    return <BaseInput ref={ref} type={type} {...props} />;
  },
);

TextInput.displayName = "TextInput";

export { TextInput };
